import { AppAction } from '@om-fe/store';
import { MatchListStoreModel } from '../../utils/match-list-models';

export const SPECIAL_MATCH_SINGLE_AGGREGATOR: string = 'special-markets-single-selection-aggregator';
export const SPECIAL_MATCH_MULTI_AGGREGATOR: string = 'special-markets-multiple-selections-aggregator';

export const slicePrefix: string = 'special-match';

export interface SpecialMatchListTopic {
    readonly path: string;
}

export interface SpecialMatchListStoreModel extends MatchListStoreModel {
    readonly ready: boolean;
    readonly isLoadingMoreData: boolean;
    readonly isLoadingData: boolean;
    readonly totalRecords: number;
    readonly limit: number;
}

export enum SpecialMatchListActions {
    SetLoadingData = 'sports:special-match-list:set-loading-data',
    SetFilterData = 'sports:special-match-list:set-match-list-filter-data',
}

export interface SpecialMatchListSetLoadingData extends AppAction<SpecialMatchListActions.SetLoadingData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly isLoadingMoreData: boolean;
    };
}

export interface SpecialMatchListSetFilterDataAction extends AppAction<SpecialMatchListActions.SetFilterData> {
    readonly meta: {
        readonly slice: string;
    };
}

export type SpecialMatchListTopicModel = SpecialMatchListTopic;
